<bw-modal-legacy>
  <typography-legacy title-medium [innerHTML]="title | translate"></typography-legacy>
  <div class="body">
    <bw-spinner-legacy brightsideWebTimeout *ngIf="loading"></bw-spinner-legacy>
    <div *ngIf="phoneNumber">
      {{prompt | translate}}:
      {{ phoneNumber|phone }}
    </div>
  </div>
  <div class="footer">
    <button bw-button-legacy (click)="emitClick()">{{ ctaText | translate }}</button>
  </div>
</bw-modal-legacy>
